import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { DataHandlerService } from '../../../shared/services/data-handler.service';
import { ActivityInfo } from '../../calendars/calendars.models';
import { Campaign } from '../campaigns.models';


@Injectable()

export class CampaignEditorService
{
  private dataHandler = inject(DataHandlerService);
  public configurationService = inject(ConfigurationService);

  private _rowsSelected: ActivityInfo[] = [];

  constructor()
  {

  }

  private _campaign: Campaign;

  get campaign(): Campaign
  {
    return this._campaign;
  }
  set campaign(value: Campaign)
  {
    this._campaign = value;
  }

  get rowsSelected(): ActivityInfo[]
  {
    return this._rowsSelected;
  }
  set rowsSelected(value: ActivityInfo[])
  {
    this._rowsSelected = value;
  }








  



}
